// extracted by mini-css-extract-plugin
export default {"pending":"Pending_pending__zMXOa","title":"Pending_title__ZEhX4"};